import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';
import MediaQueries from '../../../../styles/Grid/MediaQueries';

export const containerMarginCss = css({
  margin: '40px 0 24px',
  [MediaQueries.lgAndUp]: {
    marginTop: 64,
  },
});

export const headlineCss = css(typography.effra48, {
  color: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  position: 'relative',
  marginBottom: 24,
  [MediaQueries.mdAndUp]: {
    marginBottom: 16,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 15,
  },
});
